import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory, Link } from 'react-router'
import { isIOs, isMobile } from '../../misc/selectors'

const mapStateToProps = (state, ownProps) => {
  const { videos, me } = state

  return {
    isIOs: isIOs(state),
    me,
    isMobile: isMobile(state),
  }
}

class StartCard extends Component {
  render() {
    return (
      <div className="start-pane">
        <div className="start-form">
          <div style={{'position': 'relative'}}>
            <img src="https://statics.streamable.com/static/landing/swoosh.jpg" className="swoosh"/> 
            <h1 style={{'position': 'relative'}}>
              Video hosting made easy.
            </h1>
          </div>
          <div className="subhead">Join thousands of businesses and creators who trust Streamable to upload and share their videos.</div>
          <Link to="/signup" className="btn blue-button upload-button">Start uploading &mdash; it's free!</Link>
        </div>
        <img className="dashboard-img" src="https://statics.streamable.com/static/landing/dashboard-wide-min.png"></img>
      </div>
    )
  }
}

export default connect(mapStateToProps)(StartCard)
